var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01593 17.3917V15.1417H12.0034C13.1847 15.1417 14.2112 14.7667 15.0831 14.0167C15.955 13.2667 16.3909 12.3292 16.3909 11.2042C16.3909 10.0792 15.955 9.14172 15.0831 8.39172C14.2112 7.64172 13.1847 7.26672 12.0034 7.26672H4.91593L7.84093 10.1917L6.26593 11.7667L0.64093 6.14172L6.26593 0.516724L7.84093 2.09172L4.91593 5.01672H12.0034C13.8222 5.01672 15.3831 5.60735 16.6862 6.7886C17.9894 7.96985 18.6409 9.44172 18.6409 11.2042C18.6409 12.9667 17.9894 14.4386 16.6862 15.6198C15.3831 16.8011 13.8222 17.3917 12.0034 17.3917H4.01593Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.a73286723c0531f70dff010d180c9938.svg";
export { ForwardRef as ReactComponent };